<template>
  <div id="app">
    <app-header></app-header>
    <app-header-desktop></app-header-desktop>
    <router-view></router-view>
    <!-- <app-back-to-top></app-back-to-top>
    <app-call></app-call> -->
    <app-footer></app-footer>
    <cookie-law theme="dark-lime" :buttonText="'Am inteles!'">
        <div slot="message">
            Acest site foloseste cookies si tehnologii asemanatoare pentru a-ti imbogati experienta. <router-link to="/politica-de-cookies">Afla mai multe</router-link>
        </div>
    </cookie-law>
  </div>
</template>

<script>
    import appFooter from './components/Shared/Footer'
    import appHeader from './components/Shared/Header'
    import appHeaderDesktop from './components/Shared/HeaderDesktop'
    import appBackToTop from './components/Shared/backToTop'
    import appCall from './components/Shared/call'

    export default {
        components: {
            appFooter,
            appHeader,
            appHeaderDesktop,
            appBackToTop,
            appCall
        }
    }
</script>

<style>
    .Cookie__content {
        font-size: 15px;
    }
</style>
